import './assets/main.css'

import Vue from 'vue'
import App from './App.vue'
import Buefy from "buefy"
import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import store from './store'
import router from './router'
import axios from "axios"
import FlashMessage from '@smartweb/vue-flash-message';
import VueMeta from 'vue-meta'
import './ml'

Vue.prototype.$http = axios
if (store.getters["auth/btoken"]) {
    Vue.prototype.$http.defaults.headers.common['btoken'] = store.getters["auth/btoken"]
}
store.commit('data/app_version', process.env.VUE_APP_VERSION)
Vue.prototype.$http.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status === 401) {
        store.dispatch('auth/logout')
        return Promise.reject(error)
    }
    return Promise.reject(error)
})
Vue.prototype.$http.interceptors.request.use((request) => {
    request.headers.common['X-User-Lang'] = localStorage.getItem('vueml-lang');

    return request
})
Vue.mixin({
    methods: {
        chunk_array: (arr, size) =>
            Array.from({length: Math.ceil(arr.length / size)}, (v, i) =>
                arr.slice(i * size, i * size + size)
            )
    },
})

Vue.use(Buefy)
Vue.use(VueMeta)
Vue.use(FlashMessage, {time: 4000})
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
